module.exports = __webpack_public_path__ + "media/images/emblems/Rueschegg-coat_of_arms-1338e2bc1ff8a8f7fa4ad74b82727510.svg";